import { Component, HostListener , ChangeDetectionStrategy } from '@angular/core';
//import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { SoundManagerService } from './shared/services/sound-manager/sound-manager.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  constructor(private soundManager: SoundManagerService) { }

  @HostListener('document:visibilitychange')
  handleVisibilityChange() {
    if (document.hidden) { // doucument.hidden will be true if the tab inactive
      this.soundManager.muteAllSounds();
    } else {
      this.soundManager.unmuteAllSounds();
    }
  }
  title = 'gms-revamp';
  /*  public beforeChange($event: NgbPanelChangeEvent) {
  
      if ($event.panelId === 'preventchange-2') {
        $event.preventDefault();
      }
  
      if ($event.panelId === 'preventchange-3' && $event.nextState === false) {
        $event.preventDefault();
      }
    }*/
}
//ng config schematics.@schematics/angular:component.style scss